import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * The value of an id a caller must already have. A mutation is fired from a screen that has
 * chosen its subject, so a missing id here is a wiring mistake rather than a state the user can
 * reach - and it is worth failing by name instead of putting `undefined` in a request path.
 */
export function vereist<T>(waarde: T | undefined | null, naam: string): T {
  if (waarde === undefined || waarde === null) {
    throw new Error(`${naam} ontbreekt.`);
  }

  return waarde;
}
